import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import SelectionList from './SelectionList'

const Stage = ({ stage, audiences, availableStages, audienceSelections, store, currency }) => {
    const isDisabled = !availableStages.includes(stage.id)
    const [isOpen, setIsOpen] = useState(true)
    const selectedIds = audienceSelections[stage.id.toLowerCase()] || {}
    const selectedAudience = audiences.filter((audience) => Object.values(selectedIds).includes(audience.id))
    const toggleOpen = () => setIsOpen(!isOpen)

    return (
        <div key={stage.id} className="tw:flex tw:gap-4 tw:flex-col">
            <div className="tw:flex tw:justify-between tw:items-center tw:px-6">
                <div className="tw:inline-flex tw:gap-2 tw:items-center" onClick={toggleOpen}>
                    {!isDisabled && (
                        <>
                            <div className="tw:w-4">
                                <ChevronDown
                                    className={cn(
                                        'tw:size-4 tw:cursor-pointer tw:text-blue-300 tw:transition-transform tw:duration-300',
                                        selectedAudience.length === 0 && 'tw:hidden',
                                        isOpen && 'tw:rotate-180',
                                    )}
                                />
                            </div>
                            <div className="tw:size-3 tw:rounded-full" style={{ backgroundColor: stage.color }}></div>
                        </>
                    )}
                    {isDisabled && <div className="tw:size-3 tw:rounded-full tw:border-2 tw:border-gray-200"></div>}
                    <span className="tw:text-sm tw:font-semibold tw:cursor-pointer">{stage.name}</span>
                </div>
            </div>

            <div
                className={cn(
                    'tw:overflow-hidden tw:transition-all tw:duration-300 tw:ease-in-out',
                    selectedAudience.length > 0 && isOpen ? 'tw:max-h-96 tw:opacity-100' : 'tw:max-h-0 tw:opacity-0',
                )}
            >
                {selectedAudience.length > 0 && !isDisabled && (
                    <div className="tw:flex tw:flex-col tw:border-t tw:border-b tw:divide-y tw:mb-4">
                        <SelectionList
                            store={store}
                            stageId={stage.id}
                            currency={currency}
                            color={stage.color}
                            audiences={selectedAudience}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

const Stages = ({ allStages, audiences, availableStages, audienceSelections, store, currency }) => {
    return (
        <div className="tw:flex tw:flex-col tw:gap-2">
            {allStages.map((stage) => (
                <Stage
                    stage={stage}
                    store={store}
                    key={stage.id}
                    currency={currency}
                    audiences={audiences}
                    availableStages={availableStages}
                    audienceSelections={audienceSelections}
                />
            ))}
        </div>
    )
}

export default Stages
